import type { Icon } from "@phosphor-icons/react";
import { CalendarBlankIcon } from "@phosphor-icons/react/dist/ssr/CalendarBlank";
import { GearSixIcon } from "@phosphor-icons/react/dist/ssr/GearSix";
import { HouseIcon } from "@phosphor-icons/react/dist/ssr/House";
import { MegaphoneIcon } from "@phosphor-icons/react/dist/ssr/Megaphone";
import { PhoneIcon } from "@phosphor-icons/react/dist/ssr/Phone";
import { UsersIcon } from "@phosphor-icons/react/dist/ssr/Users";

export interface SmbNavItem {
	key: string;
	title: string;
	href: string;
	icon: Icon;
}

// Slim SMB navigation. Vocabulary is owner-facing on purpose:
// never expose prompts/plugins/campaigns/tenants to SMB users.
export const smbNavItems: SmbNavItem[] = [
	{ key: "home", title: "Home", href: "/", icon: HouseIcon },
	{ key: "calls", title: "Calls", href: "/calls", icon: PhoneIcon },
	{ key: "calendar", title: "Calendar", href: "/calendar", icon: CalendarBlankIcon },
	{ key: "customers", title: "Customers", href: "/customers", icon: UsersIcon },
	{ key: "outreach", title: "Outreach", href: "/outreach", icon: MegaphoneIcon },
	{ key: "settings", title: "Settings", href: "/settings", icon: GearSixIcon },
];

// Where a business goes when phone setup needs a person.
export const smbSupportEmail = "support@adaptivex.sg";

export function isSmbNavItemActive(item: SmbNavItem, pathname: string): boolean {
	if (item.href === "/") {
		return pathname === "/";
	}

	return pathname.startsWith(item.href);
}
